export default __webpack_public_path__ + "static/media/Winter_12.7d1142cd.png";